import {lazy} from 'react';

export const PopupLazy = lazy(() => import(/* webpackChunkName: "popup" */ '.'));
